import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {useEffect, useState} from "react";
import globalMU from "globalMU";
import {IOrcamento} from "../../../types/IOrcamento";
import {useAppSelector} from "../../../redux/hooks";
import {obterPermissao} from "../../../use-cases/obterPermissao";

const estiloAbaFrete = require("./aba-frete.module.scss").default;

export type Frete = {
  Carga: string;
  "DescricaoTipoEntrega": string,
  "PesoTotal": number,
  "Ticket": string,
  "TipoEntrega": string,
  "Valor": number,
  "UserMessage"?: string,
  "Transforming": boolean
};

export type AbaFreteProps = {
  todosFrete: Frete[];
  onEditarFrete: (frete: Frete) => void;
  parametroUtilizaCargaFrete: string
  permitidoEditar: boolean
};

export const AbaFrete = (props: AbaFreteProps) => {
  const [permitidoFrete, setPermitidoFrete] = useState<boolean>(true)
  const permitidoAcaoFuncionalidade = async (siglaFuncionalidade: string, acao?: string) =>
      await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
  const obterPermissoes = async () => {
    setPermitidoFrete(await permitidoAcaoFuncionalidade("ORCAMENTO_FRETE", "CONSULTAR"))
  }
  useEffect(() => {
    obterPermissoes()
  }, [])


  return  props.todosFrete?.length > 0 && permitidoFrete && <div className={estiloAbaFrete.separador}>

    <div id="tabela-tipos-entrega" className={estiloAbaFrete.tabela}>
      <div
        id="AbaFrete_Cabecalho"
      >
        <div>Carga</div>
        <div>Tipo Entrega</div>
        <div>Ticket</div>
        <div style={{justifyContent: "flex-end"}}>Valor do Frete</div>
        <div style={{justifyContent: "flex-end"}}>Peso Total</div>
        <div></div>
      </div>

      {props.todosFrete?.map((frete, index) => {
        return (
            <div className={estiloAbaFrete.linha}
              key={`frete-${index}`}
              id={`AbaFrete_LinhaFrete_${index}`}
            >
              <div>{frete.Carga.toUpperCase()}</div>
              <div>{frete.DescricaoTipoEntrega}</div>
              <div>{frete.Ticket}</div>
              <div style={{justifyContent: "flex-end"}}>
                {globalMU.formatarValorNumerico(orcamento.ValorFrete > 0 ? orcamento.ValorFrete : frete.Valor, 2, true)}
              </div>
              <div style={{justifyContent: "flex-end"}}>
                {globalMU.formatarValorNumerico(frete.PesoTotal, 3, false)}
              </div>
              <div>
                {props.permitidoEditar && <FontAwesomeIcon
                    className={estiloAbaFrete.icone_editar}
                    icon={faPenToSquare}
                    onClick={(e) => props.onEditarFrete(frete)}
                />
                }
              </div>
            </div>
        );
      })}
    </div>
    {<section style={{ marginBottom: "30px" }} />}
  </div>
};
